<template>
  <v-dialog v-model="dialog" @input="cancel" width="500">
    <v-card v-if="ebat && ebat.id">
      <v-card-title class="text-h6 grey lighten-4 mb-4">
        Devolver BO{{ ebat.number.toString().padStart(7, "0") }}
      </v-card-title>

      <v-card-text>
        O boletim será devolvido para o agente que fez o cadastro, no caso o
        responsável é: <b>{{ ebat.author.nickname }}</b>
      </v-card-text>

      <v-divider />
      <v-card-actions class="justify-end px-4 py-4">
        <v-btn
          color="primary"
          outlined
          :disabled="devolvendo"
          @click="devolverEbat"
          >Devolver</v-btn
        >
      </v-card-actions>
    </v-card>

    <div v-else>
      <v-overlay :value="true">
        <v-progress-circular indeterminate size="64" />
      </v-overlay>
    </div>
  </v-dialog>
</template>
<script>
import urlApi from "@/routes/urlApi";
import { showError } from "@/global";

export default {
  name: "DevolverDialog",
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      ebat: {},
      dialog: false,
      devolvendo: false,
    };
  },

  methods: {
    async devolverEbat() {
      try {
        this.devolvendo = true;
        await this.$http.patch(`${urlApi}/v2/ebats/${this.ebat.id}/devolver`);
        this.close();
      } catch (error) {
        showError(error);
      } finally {
        this.devolvendo = false;
      }
    },
    open(ebat) {
      this.ebat = ebat;
      this.dialog = true;
    },
    cancel() {
      this.close();
    },
    close() {
      this.ebat = {};
      this.dialog = false;
    },
  },
};
</script>
